// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"698":"ae41e2c8","763":"5f05011a"}[chunkId] + ".chunk.css";
};